import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchBranding } from '../brandingApi/brandingApi';
import { brandingQueries } from '../utils/queries';

export const useBranding = (accountId: number) => {
  return useSuspenseQuery({
    queryKey: brandingQueries.brand({ id: accountId }),
    queryFn: async () => {
      const branding = await fetchBranding({ id: accountId });
      return branding;
    },
  });
};
